module.exports = __webpack_public_path__ + "static/img/logo_large.588d4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo_large.png
// module id = fRcb
// module chunks = 7